module.exports = __webpack_public_path__ + "static/media/icon_tempo.539b4c61.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/icon_tempo.png
// module id = 967
// module chunks = 0